var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWbo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 27C19.6863 27 17 24.3137 17 21V15.4444C17 15.0306 17 14.8237 17.0603 14.658C17.1614 14.3802 17.3802 14.1614 17.658 14.0603C17.8237 14 18.0306 14 18.4444 14H27.5556C27.9694 14 28.1763 14 28.342 14.0603C28.6198 14.1614 28.8386 14.3802 28.9397 14.658C29 14.8237 29 15.0306 29 15.4444V21C29 24.3137 26.3137 27 23 27ZM23 27V30M29 16H31.5C31.9659 16 32.1989 16 32.3827 16.0761C32.6277 16.1776 32.8224 16.3723 32.9239 16.6173C33 16.8011 33 17.0341 33 17.5V18C33 18.93 33 19.395 32.8978 19.7765C32.6204 20.8117 31.8117 21.6204 30.7765 21.8978C30.395 22 29.93 22 29 22M17 16H14.5C14.0341 16 13.8011 16 13.6173 16.0761C13.3723 16.1776 13.1776 16.3723 13.0761 16.6173C13 16.8011 13 17.0341 13 17.5V18C13 18.93 13 19.395 13.1022 19.7765C13.3796 20.8117 14.1883 21.6204 15.2235 21.8978C15.605 22 16.07 22 17 22M18.4444 34H27.5556C27.801 34 28 33.801 28 33.5556C28 31.5919 26.4081 30 24.4444 30H21.5556C19.5919 30 18 31.5919 18 33.5556C18 33.801 18.199 34 18.4444 34Z",
    stroke: "#3B3B3B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWbo);
export default __webpack_public_path__ + "static/media/wbo.79f96aa0b283bca2dbdb81ae94ab373d.svg";
export { ForwardRef as ReactComponent };